import { getCookie } from "../actions";
import { AnalyticParams } from "../constants";
import type { AnalyticParamsType } from "../types";
import { validateAnalyticsParam } from "../utils";
import { getFBPAnalyticsParam } from "./get-fbp";

export const getAnalyticsParam = (param: AnalyticParamsType): string | undefined => {
  switch (param) {
    case AnalyticParams.FBP:
      return getFBPAnalyticsParam();
    default:
      return getDefaultAnalyticsParam(param);
  }
};

const getDefaultAnalyticsParam = (param: AnalyticParamsType): string | undefined => {
  const searchParams = new URLSearchParams(window.location.search);

  const search = searchParams.get(param);
  const cookie = getCookie(param);

  return validateAnalyticsParam(search, cookie);
};
